import { DaisyAtlaOption } from "../models/daisyatlaoption.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getDaisyAtlaOptionsList = (): Promise<DaisyAtlaOption[]> => {
    return new Promise<DaisyAtlaOption[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/daisy/atla/optionslist`).then((response) => {
            resolve(response.data as DaisyAtlaOption[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};